// extracted by mini-css-extract-plugin
module.exports = {"mapCard":"ImageSlider_mapCard__k7jrV","prev":"ImageSlider_prev__8GTP5","next":"ImageSlider_next__qFpH5","caption":"ImageSlider_caption__cHhP7"};